export default "__VITE_ASSET__CtO$1XL5__"